import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { ActionWithPayload } from "@obg/ngrx-utils";
import { TelemetryService } from "@obg/ngx.global";
import { distinct, map } from "rxjs/operators";

import { JURISDICTION_ACTION_TYPE } from "./jurisdiction.action";
import { Jurisdiction } from "./jurisdiction.model";

@Injectable()
export class JurisdictionTelemetryEffect {
	jurisdictionChange$ = createEffect(
		() =>
			this.actions$.pipe(
				ofType(JURISDICTION_ACTION_TYPE.getSuccess, JURISDICTION_ACTION_TYPE.set),
				map(({ payload }: ActionWithPayload<Jurisdiction>) => payload.toUpperCase()),
				distinct(),
				map((newJurisdiction) => this.telemetryService.track({ Jurisdiction: newJurisdiction }))
			),
		{ dispatch: false }
	);

	constructor(
		private actions$: Actions,
		private telemetryService: TelemetryService
	) {}
}
